import { Label } from "./Label";

export class LabelList {
  /**
   * @param {Label[]} items
   * @param {Number} total
   * @param {Number} page
   * @param {Number} limit
   */
  constructor(items, total, page, limit) {
    this.items = items;
    this.total = total;
    this.page = page;
    this.limit = limit;
  }

  /**
   * Create LabelList from API response
   *
   * API Request Spec:
   * GET /subscriptions/package-labels?name={name}&page={page}&limit={limit}
   *
   * API Response Spec:
   * {
   *   "result": {
   *     "pagination": {
   *       "total_records": 3,
   *       "page": 1,
   *       "limit": 10
   *     },
   *     "labels": [
   *       {
   *         "id": 1,
   *         "name": {
   *           "th": "เครื่องปรับอากาศ",
   *           "en": "Air",
   *           "zh": "空调"
   *         },
   *         "package_ids": []
   *       }
   *     ]
   *   }
   * }
   *
   * @param {Object} response
   * @return {LabelList}
   */
  static createFromResponse(response) {
    const { result } = response;
    const { pagination, labels = [] } = result;

    const items = labels.map((label) => Label.createFromResponse(label, false));

    return new LabelList(
      items,
      pagination.total_records,
      pagination.page,
      pagination.limit
    );
  }
}
